import { render } from "./DetailsTab.vue?vue&type=template&id=0ff7e81c"
import script from "./DetailsTab.vue?vue&type=script&lang=js"
export * from "./DetailsTab.vue?vue&type=script&lang=js"

import "./DetailsTab.vue?vue&type=style&index=0&id=0ff7e81c&lang=css"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__